export function formatCoverageScore(score: number | null | undefined): string {
  if (score == null || !Number.isFinite(score)) return '—';
  return `${Number(score.toFixed(1))}%`;
}
